<app-breadcrumb [title]="'current year'|translate" [items]="['security'|translate]" [active_item]="'current year'|translate"></app-breadcrumb>
<style>
  .custom-card-erp{
    margin-bottom: 30px;
    display: flex;
    flex-direction: column;
  }

  @media screen and (max-width: 800px) {
    .desktop-hidden {
      display: initial;
    }
    .mobile-hidden {
      display: none;
    }
  }
  @media screen and (min-width: 800px) {
    .desktop-hidden {
      display: none;
    }
    .mobile-hidden {
      display: initial;
    }
  }

</style>

<div class="container-fluid">
  <div class="row">
    <div class="col-sm-12">


      <div class="custom-card-erp">
        <div style="float:left;">
          <input
                  type="text"
                  style="padding:5px;margin:5px auto;width:30%;"
                  placeholder="Type to filter the name column..."
                  (keyup)="updateFilter($event)"
          />

          <div class="btn-group-vertical" role="group" aria-label="Vertical button group" *ngIf="this.isButtonVisible">
            <div ngbDropdown class="btn-group" role="group">
              <button type="button" class="btn btn-outline-primary dropdown-toggle" id="dropdownBasic1"
                      ngbDropdownToggle>{{'dropdown'|translate}}</button>
              <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                <button class="dropdown-item">{{'dropdown link'|translate}}</button>
              </div>
            </div>
          </div>

        </div>


        <ngx-datatable
                style="width: 100%"
                class="material striped"
                selectionType="checkbox"
                [rows]="rows"
                [headerHeight]="50"
                [footerHeight]="50"
                [limit]="10"
                rowHeight="auto"
                columnMode="force"
                [scrollbarH]="true"
                [loadingIndicator]="loadingIndicator"
                [reorderable]="reorderable"
                [selected]="selected"
                (activate)="onActivate($event)"
                (select)="onSelect($event)"
                [selectAllRowsOnPage]="false"
        >
          <ngx-datatable-column
                  [width]="55"
                  [sortable]="false"
                  [canAutoResize]="false"
                  [draggable]="false"
                  [resizeable]="false"
                  [headerCheckboxable]="true"
                  [checkboxable]="true"
                  [frozenLeft]="true"
          >

          </ngx-datatable-column>

          <ngx-datatable-column name="year">
            <ng-template let-column="column" ngx-datatable-header-template>
              <span class="f-w-700 sp-policy-erp">{{'year'|translate}}</span>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="startAt">
            <ng-template let-column="column" ngx-datatable-header-template>
              <span class="f-w-700 sp-policy-erp">{{'start at'|translate}}</span>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="endAt">
            <ng-template let-column="column" ngx-datatable-header-template>
              <span class="f-w-700 sp-policy-erp">{{'end at'|translate}}</span>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="actions">
            <ng-template let-column="column" ngx-datatable-header-template>
              <span class="f-w-700 sp-policy-erp">{{'actions'|translate}}</span>
            </ng-template>

            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
              <ng-container>
                <a (click)="setUserCurrentYear(row.id)" placement="top" ngbTooltip="{{'set as current'| translate}}"><i class="icon-check-box text-success ms-2" style="cursor: pointer"></i></a>
              </ng-container>

            </ng-template>

          </ngx-datatable-column>
        </ngx-datatable>

      </div>


    </div>
  </div>
</div>